<template>
    <ideo-form-group :label="$t('[[[Opis]]]')" :invalid-feedback="form.$errors.first('description')" :state="form.$errors.state('description')">
        <editor id="description" v-model="form.settings.description"></editor>
    </ideo-form-group>
    <ideo-form-group :label="$t('[[[Wyświetl do poziomu zagnieżdżenia]]]')" :invalid-feedback="form.$errors.first('settings.depth')" :state="form.$errors.state('settings.depth')">
        <ideo-form-select name="settings.depth" v-model="form.settings.depth" :options="levels"></ideo-form-select>
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import { Option } from '@/helpers/Interfaces';
import merge from 'lodash/merge';

@Options({
    name: 'module-subpageslist-settings'
})
export default class subpageslistSettings extends Vue
{
    @Prop() public modelValue!: any;

    public defaults: any = {
        description: '',
        depth: 1
    };

    public get form(): any
    {
        return this.modelValue;
    }

    public get levels(): Option<number>[]
    {
        return new Array(2).fill(null).map((value, index) =>
        {
            return { value: index + 1, text: (index + 1).toString() };
        });
    }

    public created(): void
    {
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', { deep: true })
    public onSettingsChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        return this.form;
    }
}
</script>
